if (!window.pdpNotifyTriggerReady) {
  window.pdpNotifyTriggerReady = true;

  const findProviderButton = (trigger) => {
    const productInfo = trigger.closest('product-info');
    return (
      productInfo?.querySelector('.restock-rocket-button, .restock-rocket-button-product') ||
      document.querySelector('.restock-rocket-button, .restock-rocket-button-product')
    );
  };

  const mountProvider = (trigger) => {
    const providerButton = findProviderButton(trigger);
    const row = trigger.closest('.pdp-notify__row');
    if (!providerButton || !row) return false;

    const providerContainer =
      providerButton.closest('.restock-rocket-button-container') || providerButton;
    providerContainer.classList.add('pdp-notify__provider');
    if (providerContainer.parentElement !== row) {
      row.insertBefore(providerContainer, row.firstElementChild);
    }
    trigger.hidden = true;
    return true;
  };

  const openProvider = (trigger, attempts = 0) => {
    const providerButton = findProviderButton(trigger);
    if (providerButton) {
      trigger.removeAttribute('aria-busy');
      providerButton.click();
      return;
    }

    if (attempts < 20) {
      window.setTimeout(() => openProvider(trigger, attempts + 1), 150);
    } else {
      trigger.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pdp-notify-trigger]');
    if (!trigger) return;
    event.preventDefault();
    if (trigger.getAttribute('aria-busy') === 'true') return;
    trigger.setAttribute('aria-busy', 'true');
    openProvider(trigger);
  });

  const mountProviders = () => {
    document.querySelectorAll('[data-pdp-notify-trigger]').forEach((trigger) => mountProvider(trigger));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountProviders, { once: true });
  } else {
    mountProviders();
  }

  const providerObserver = new MutationObserver(mountProviders);
  providerObserver.observe(document.documentElement, { childList: true, subtree: true });
}
